import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortUp = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.6666 2.66667H13.6666L11 0L8.33331 2.66667H10.3333V12H11.6666M0.333313 9.33333H6.99998V10.6667H0.333313M2.99998 1.33333V2.66667H0.333313V1.33333M0.333313 5.33333H4.99998V6.66667H0.333313V5.33333Z",
		fill: "currentColor",
		fillOpacity: .9
	})
});
const ForwardRef = forwardRef(SvgSortUp);
export { ForwardRef as ReactComponent };
